// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"75a9b5a1cd9ee64f4aa3","713":"8ac407604bdb5dacf9b2"}[chunkId] + ".js";
};